<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  > 
    <div v-if="config.name !== undefined || !id" class="mb-5">
      <v-row><h5 class="text--disabled">Input</h5></v-row>
      <v-row class="mb-3"><v-divider /></v-row>
      <v-row class="mb-3">
        <v-col cols="12">
          <v-text-field
            v-model="config.name"
            label="Input Name"
            @input="configChanged"
            :disabled="!canEdit"
            outlined
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    </div>
    
    <v-row><h5 class="text--disabled">SRT Input Settings</h5></v-row>
    <v-row class="mb-3"><v-divider /></v-row>
    <v-row class="mb-3">
      <v-col cols="6">
        <v-select
          v-model="config.srt_type"
          :items="srt_typeValues"
          label="Call Mode"
          @change="configChanged"
          :disabled="!canEdit"
          outlined
          hide-details
        ></v-select>
      </v-col>
    </v-row>
    
    <div v-if="config.srt_type == 'caller'">
      <v-row class="mb-5">
        <v-col cols="9">
          <v-text-field
            v-model="config.srt_ip"
            label="Destination Address"
            @input="configChanged"
            :disabled="!canEdit"
            :rules="$validations.destinationAddressValidation"
            outlined
            hide-details="auto"
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model.number="config.srt_port"
            label="Port"
            @input="configChanged"
            :disabled="!canEdit"
            type="number"
            :rules="$validations.portValidation"
            outlined
            hide-details="auto"
          ></v-text-field>
        </v-col>
      </v-row>
    </div>
    <div v-if="config.srt_type == 'listener'">
      <v-row class="mb-5">
        <v-col cols="3">
          <v-text-field
            v-model.number="config.srt_port"
            label="Listen Port"
            @input="configChanged"
            :disabled="!canEdit"
            type="number"
            :rules="$validations.portValidation"
            outlined
            hide-details="auto"
          ></v-text-field>
        </v-col>
      </v-row>
    </div>
    
    <v-row class="mb-5">
      <v-col lg="4" cols="6">
        <v-text-field
          v-model.number="config.srt_latency_ms"
          label="Latency (ms)"
          @input="configChanged"
          :disabled="!canEdit"
          type="number"
          outlined
          hide-details="auto"
        ></v-text-field>
      </v-col>
      <v-col lg="4" cols="6">
        <v-text-field
          v-model.number="config.srt_overhead_percent"
          label="Bandwidth Overhead (%)"
          @input="configChanged"
          :disabled="!canEdit"
          type="number"
          :rules="$validations.percent"
          outlined
          hide-details="auto"
        ></v-text-field>
      </v-col>
      <v-col lg="4" cols="6">
        <v-text-field
          v-model.number="config.srt_timeout_ms"
          label="Timeout (ms)"
          @input="configChanged"
          :disabled="!canEdit"
          type="number"
          outlined
          hide-details="auto"
        ></v-text-field>
      </v-col>
    </v-row>
    
    <v-row><h5 class="text--disabled">NDI Settings</h5></v-row>
    <v-row class="mb-3"><v-divider /></v-row>
    <v-row class="mb-3">
      <v-col cols="12">
        <v-text-field
          v-model="config.ndi_output_name"
          label="NDI Output Name"
          @input="configChanged"
          :disabled="!canEdit"
          outlined
          hide-details="auto"
        ></v-text-field>
      </v-col>
    </v-row>
    
    
    
    <div v-if="id && !isNew && shadowDebug" class="mt-5">
      <v-row><h5 class="text--disabled">Input Details</h5></v-row>
      <v-row class="mb-3"><v-divider /></v-row>
      <v-row class="mb-3">
        <v-col cols="12">
          <pre style="inline-size: 640px; white-space: pre-wrap;">{{ input }}</pre>
        </v-col>
      </v-row>
    </div>
    
    <div v-if="id && !isNew && canEdit" class="text-right">
      <v-btn
        class="ma-1 d-none d-md-inline"
        x-small
        outlined
        @click="deleteInput()"
      >
        Delete Input
      </v-btn>
    </div>
  </v-form>
</template>
<script>
  import { mapGetters } from 'vuex'
  import ShadowMixins from '../../mixins/mixins.js'

  export default {
    name: 'BirdDogDecoder',
    
    props: ['input', 'documents', 'device_guid', 'device', 'canEdit', 'isNew'],
    
    components: {
      
    },
    
    mixins:[ShadowMixins],
    
    data() {
      return {
        valid: true,
        
        id: '',
        
        srt_typeValues: [
          { 'value': 'caller', 'text': 'Caller' },
          //{ 'value': 'listener', 'text': 'Listener' }
        ],
        
        config: {
          'ndi_output_name': 'srt_output',
          
          'srt_type': 'caller',
          
          'srt_port': 1000,
          'srt_ip': '',
          
          'srt_timeout_ms': 30000,
          'srt_overhead_percent': 25,
          'srt_latency_ms': 120
        }
      }
    },
    
    watch: {
      input() {
        this.updateValues()
      },
    },
    
    computed: {
      ...mapGetters('userPreferences', ['shadowDebug']),
    },
    
    mounted() {
      this.updateValues()
    },
    
    methods: {
      configChanged() {
        var validationErrors = false
        
        // check for validation errors
        if (!this.$refs.form.validate()) {
          console.log('BirdDogDecoder ' + this.device_guid + ' validation error', this.config)
          validationErrors = true
        }
        
        console.log('BirdDogDecoder ' + this.device_guid + ' configChanged', this.config)
        this.$emit('configUpdate', this.config, validationErrors)
      },
      
      updateValues() {
        if (this.input && this.input.config) {
          Object.keys(this.input).map((key) => {
            this[key] = this.input[key]
          })
          
          // htmlDecode name properties
          if (this.config.name !== undefined) {
            this.config.name = this.$helpers.htmlDecode(this.config.name)
          }
        }
        
        this.configChanged()
      },
      
      deleteInput() {
        console.log('BirdDogDecoder ' + this.device_guid + ' deleteInput')
        this.$emit('deleteInput')
      }
    }
  }
</script>